"use client";

import { login } from "@hopper-b2b/utilities";
import { useEffect } from "react";
import { updateRefreshToken } from "../../utils";

const NATIVE_LOGIN_EVENT = "nativeLogin";

/** Handles auth in WebView contexts. Listens for native login events
 *  and optionally triggers the native login flow. */
export const useWebviewAuth = (triggerLogin: boolean) => {
  useEffect(() => {
    if (!window) return;

    const handler = async () => {
      await updateRefreshToken();
      window.location.reload();
    };

    window.addEventListener(NATIVE_LOGIN_EVENT, handler);
    return () => window.removeEventListener(NATIVE_LOGIN_EVENT, handler);
  }, []);

  useEffect(() => {
    if (triggerLogin) {
      login(
        "lodging-web",
        `window.dispatchEvent(new Event("${NATIVE_LOGIN_EVENT}"))`
      );
    }
  }, [triggerLogin]);
};
